import { AfterViewInit, Component, Input } from '@angular/core';
import { MbExpandablePanel, MbExpandablePanelTrigger, MbIcon } from '@am/moebius';
import { NgClass } from '@angular/common';

@Component({
  selector: 'am-benefits-banner',
  standalone: true,
  styleUrls: ['./benefits-banner.component.scss'],
  templateUrl: './benefits-banner.component.html',
  imports: [NgClass, MbExpandablePanel, MbExpandablePanelTrigger, MbIcon],
})
export class BenefitsBannerComponent implements AfterViewInit {
  @Input()
  public isDisney: boolean;
  @Input()
  public isUniversal: boolean;

  public openPanel = true;

  public temporarilyHidden = true;

  public disneyURl = '/hotels/results/dist/es-AR/browser/assets/images/Operador selecto.svg';

  public universalUrl =
    '/hotels/results/dist/es-AR/browser/assets/images/benefits-banner/proveedorOficialUniversal2023.png';

  public altImage = '';
  constructor() {}

  public togglePanel() {
    this.openPanel = !this.openPanel;
  }

  public ngAfterViewInit(): void {
    this.altImage = `Operador selecto vacaciones en ${
      this.isDisney ? 'Walt Disney Word' : 'Universal'
    }`;
  }
}
